import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IMeetingRatingsPayloadState } from '@app-store/slices/meetingStatistics/meetingRatings'

interface TaskAction extends Action {
    payload: IMeetingRatingsPayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingStatistics.meetingRatings

function* meetingRatingsSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/stats/ratings`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* meetingRatingsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, meetingRatingsSagaTask)
}

export default meetingRatingsSaga
